var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunningIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#EEF4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8087 20.5422C32.0685 20.5422 33.0899 19.5254 33.0899 18.2711C33.0899 17.0168 32.0685 16 30.8087 16C29.5488 16 28.5275 17.0168 28.5275 18.2711C28.5275 19.5254 29.5488 20.5422 30.8087 20.5422Z",
    fill: "#1162FF",
    stroke: "#1162FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.972 22.5362C35.076 22.4867 35.1927 22.4588 35.3159 22.4588C35.7563 22.4588 36.1134 22.8143 36.1134 23.2527C36.1134 23.494 36.005 23.7103 35.8346 23.8559L33.0982 25.9878C32.8923 26.1574 32.6278 26.2594 32.3391 26.2594C32.0845 26.2594 31.849 26.18 31.6554 26.0446L29.7979 24.4464L30.7205 22.2307L32.5564 24.0124L34.972 22.5362Z",
    fill: "#1162FF",
    stroke: "#1162FF",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8903 31.0733L22.6396 27.5663L26.0943 27.0779L22.8098 32.5265L19.1411 34.5804C17.3561 35.3428 16.5116 33.5799 17.7674 32.7188L20.8903 31.0733Z",
    fill: "#1162FF",
    stroke: "#1162FF",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2901 35.5263C26.2546 35.5263 26.2182 35.5248 26.1793 35.5219C25.763 35.49 25.266 35.155 25.1897 34.6695C25.133 34.3115 25.2365 33.9432 25.497 33.5744L27.7738 30.3402L24.1439 29.0376C23.3493 28.8346 22.7962 28.125 22.7962 27.306C22.7962 27.0652 22.8434 26.8313 22.937 26.6111L22.94 26.6037L24.9217 22.5519L22.5661 22.1768L19.6391 23.6274L19.6165 23.6343C19.5115 23.6666 19.4022 23.6833 19.2914 23.6833C19.2431 23.6833 19.1943 23.6804 19.146 23.674C18.6564 23.6102 18.2702 23.2253 18.2077 22.7373C18.153 22.3131 18.353 21.8938 18.7165 21.6697L22.1582 19.6261L22.1912 19.6158C22.2972 19.583 22.4075 19.5658 22.5188 19.5658H22.5326L28.0329 20.0758C29.3703 20.0837 30.456 21.191 30.456 22.5514C30.456 23.0718 30.2776 23.5803 29.9402 24.0222L29.9363 24.0276L27.6053 26.8018L29.9511 28.0808L29.9796 28.0995C30.3978 28.3751 30.9185 28.7179 31.0668 29.4363C31.151 29.8434 31.0609 30.2337 30.7914 30.63L30.7855 30.6388L27.2812 35.0515L27.2605 35.0692C26.9275 35.359 26.6625 35.5263 26.2901 35.5263Z",
    fill: "#1162FF",
    stroke: "#1162FF",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningIconBlue);
export default __webpack_public_path__ + "static/media/RunningIconBlue.840e6c1d.svg";
export { ForwardRef as ReactComponent };